// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Jzf2","title":"Header_title__LP14T","side":"Header_side__2nM9C"};